import React from "react";
import styled from "styled-components";
import { NAV_HEIGHT } from "./Nav";
import { HEIGHT as StatusBarHeight } from "./RecordingStatusBar";
import { decorate, observable, action } from "mobx";
import { observer } from "mobx-react";

const FLASH_MESSAGE_MS = 1250;

type MessageType = "success" | "info" | "warn";

export interface IFlashMessage {
  message: string;
  type?: MessageType;
  queued: number;
}

class FlashStore {
  activeMessage: IFlashMessage | null = null;

  showSuccess(message: string) {
    this.showMessage(message, "success");
  }

  showWarning(message: string) {
    this.showMessage(message, "warn", 1750);
  }

  showMessage(message: string, type: MessageType, time = FLASH_MESSAGE_MS) {
    const newMessage: IFlashMessage = {
      message,
      type,
      queued: Date.now()
    };

    this.activeMessage = newMessage;

    setTimeout(() => {
      if (this.activeMessage && this.activeMessage.queued === newMessage.queued) this.activeMessage = null;
    }, time);
  }
}

decorate(FlashStore, {
  activeMessage: observable,
  showMessage: action
});

export const FlashControl = new FlashStore();

const HEIGHT = StatusBarHeight;

const StyledFlashMessage = styled.div`
  position: fixed;
  top: ${NAV_HEIGHT}px;
  width: 100%;
  height: ${HEIGHT}px;
  line-height: ${HEIGHT}px;
  color: white;
  background: ${props => props.theme.colors.gray2};
  z-index: 10;
  font-size: 0.85rem;
  text-align: center;

  &.type-success {
    background: ${props => props.theme.colors.green};
  }

  &.type-warn {
    background: ${props => props.theme.colors.danger};
  }
`;

interface Props {}

const FlashMessage: React.FC<Props> = () => {
  const message = FlashControl.activeMessage;

  if (message) {
    return <StyledFlashMessage className={`type-${message.type}`}>{message.message}</StyledFlashMessage>;
  }
  return <></>;
};

export default observer(FlashMessage);
